import { CoreEvent, eventNames } from '@carvana/core-events';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useEffect } from 'react';
import UserContext, { useIsLoggedIn } from '~/context/common/UserContext';

export default function useSynchronizeAuth() {
  const { logInFlag, logOutFlag, triggerEvent } = useContext(UserContext);
  const isLoggedIn = useIsLoggedIn();

  useEffect(() => {
    if (isLoggedIn) triggerEvent.logIn();
  }, [isLoggedIn, triggerEvent]);

  useSubsequentEffect(() => {
    CoreEvent.emit(eventNames.auth.change);
  }, [logInFlag]);

  useSubsequentEffect(() => {
    CoreEvent.emit(eventNames.auth.change);
  }, [logOutFlag]);

  useEffect(() => {
    const logInListener = () => {
      triggerEvent.logIn();
    };

    const logOutListener = () => {
      triggerEvent.logOut();
    };

    CoreEvent.on(eventNames.auth.login, logInListener);
    CoreEvent.on(eventNames.auth.userLoggedOut, logOutListener);

    return () => {
      CoreEvent.off(eventNames.auth.login, logInListener);
      CoreEvent.off(eventNames.auth.userLoggedOut, logOutListener);
    };
  }, [triggerEvent]);
}
